exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price[data-v-6b4c13cf] {\n  white-space: nowrap;\n  font-size: 1.6rem;\n  line-height: 1;\n  margin-bottom: 0;\n  font-weight: bold;\n}\n.anchor[data-v-6b4c13cf] {\n  white-space: nowrap;\n  font-size: small;\n  color: #9e9e9e;\n  text-decoration: line-through;\n}", ""]);

// exports
